module.exports = __webpack_public_path__ + "img/heavy-equipment.f58e5d60.svg";